import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-delegate-explanation',
  templateUrl: './delegate-explanation.component.html',
  styleUrls: ['./delegate-explanation.component.scss']
})
export class DelegateExplanationComponent implements OnInit {
  @Input() public explanation;

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
